const PaymentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#add8e4"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#add8e4"
      fillRule="evenodd"
      d="m36.537 20.338-2.432-4.212L19.601 24.5H17V47h30V24.5h-3.247l-3.606-6.246-3.61 2.084Zm4.33 4.162-1.635-2.83-4.903 2.83h6.537Zm-11.538 0 5.043-2.912-1.182-2.048-8.59 4.96h4.729Zm15.171 20v-5h-4.583a3.75 3.75 0 1 1 0-7.5H44.5v-5h-25v17.5h25Zm-4.583-10H44.5V37h-4.583l-.12-.006a1.25 1.25 0 0 1-1.13-1.244l.005-.12a1.25 1.25 0 0 1 1.245-1.13Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="m36.537 20.338-2.432-4.212L19.601 24.5H17V47h30V24.5h-3.247l-3.606-6.246-3.61 2.084Zm4.33 4.162-1.635-2.83-4.903 2.83h6.537Zm-11.538 0 5.043-2.912-1.182-2.048-8.59 4.96h4.729Zm15.171 20v-5h-4.583a3.75 3.75 0 1 1 0-7.5H44.5v-5h-25v17.5h25Zm-4.583-10H44.5V37h-4.583l-.12-.006a1.25 1.25 0 0 1-1.13-1.244l.005-.12a1.25 1.25 0 0 1 1.245-1.13Z"
      clipRule="evenodd"
    />
  </svg>
);
export default PaymentIcon;
